import { InternalExpenditureService } from "../../../../client"
import { useCreateWarehouseDocumentDraft } from "../../shared/useCreateWarehouseDocumentDraft"

// useCreateRW persists a minimal RW draft and opens the shared detail editor.
export function useCreateRW() {
  const { createDocument, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWarehouseDocumentDraft({
      mutationKey: ["wms", "internal-expenditure", "rw"] as const,
      documentCode: "RW",
      blockedWarehouseDescription:
        "Magazyn z kontekstu jest obecnie zablokowany przez aktywną inwentaryzację.",
      missingWarehouseDescription:
        "Brak aktywnego magazynu dostępnego do utworzenia dokumentu RW.",
      createDraftRequest: (payload: { warehouse_id: string }) =>
        InternalExpenditureService.initDocumentRWDraft(payload),
      buildPayload: (warehouseId: string) => ({
        warehouse_id: warehouseId,
      }),
      getSuccessNavigation: (draft) => ({
        to: "/WMS/documents/doc-rw/$docRw",
        params: { docRw: draft.id },
        search: { tab: "general", edit: 1 },
      }),
    })

  return {
    createRW: (preferredWarehouseId?: string) =>
      createDocument({ preferredWarehouseId }),
    isCreating,
    isResolvingWarehouses,
    canCreate,
  }
}
